export enum SocketEvents {
  AUTO_REFRESH_LEAD_PAGE = 'AUTO_REFRESH_LEAD_PAGE',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  DISMISS_REMINDER_ACTIVITY = 'DISMISS_REMINDER_ACTIVITY',
  LEAD_NAME_UPDATE = 'LEAD_NAME_UPDATE',
  LEAD_OWNER_UPDATE = 'LEAD_OWNER_UPDATE',
  LEAD_PROCESS_UPDATE = 'LEAD_PROCESS_UPDATE',
  LEAD_STATUS_UPDATE = 'LEAD_STATUS_UPDATE',
  OBJECT_UPDATE_TIMESTAMP = 'OBJECT_UPDATE_TIMESTAMP',
  PUSH_END_CALL = 'PUSH_END_CALL',
  PUSH_PERMISSION_CONTROL = 'PUSH_PERMISSION_CONTROL',
  PUSH_REMINDER_ACTIVITY = 'PUSH_REMINDER_ACTIVITY',
  QUOTATION_STATUS_UPDATE = 'QUOTATION_STATUS_UPDATE',
  UPDATE_TOKEN = 'UPDATE_TOKEN',
  WORKFLOW_PROCESS_STAGE_ADD = 'WORKFLOW_PROCESS_STAGE_ADD',
  WORKFLOW_PROCESS_STAGE_DELETE = 'WORKFLOW_PROCESS_STAGE_DELETE',
  WORKFLOW_STATUS_DELETE = 'WORKFLOW_STATUS_DELETE',
  LEAD_DETAIL_PAGE_LAYOUT_UPDATE = 'LEAD_DETAIL_PAGE_LAYOUT_UPDATE',
}
